export const LOCAL_STORAGE_AUTH_USER = "authUser";
export const LOCAL_STORAGE_LAYOUT_THEME = "layoutTheme";
export const LOCAL_STORAGE_LOCK_SCREEN = "screen";
